import { render } from "./DialogOk.vue?vue&type=template&id=453a4c7e"
import script from "./DialogOk.vue?vue&type=script&lang=js"
export * from "./DialogOk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__